import { render, staticRenderFns } from "./bar_chart.vue?vue&type=template&id=40dae7a9&scoped=true&"
import script from "./bar_chart.vue?vue&type=script&lang=js&"
export * from "./bar_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dae7a9",
  null
  
)

export default component.exports